import React from 'react';

/* Added the following code for POW-950.Harsha using AI Agent. October 9, 2026. Code Start */
const ManageUsersConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: '/securitysetup/manageusers',
			component: React.lazy(() => import('./ManageUsers'))
		}
	]
};

export default ManageUsersConfig;
/* Code end. Harsha using AI Agent. October 9, 2026 */
